import * as React from 'react';
import * as _ from 'lodash';
import BigNumber from 'bignumber.js';
import * as numeral from 'numeral';
import { PFBalanceProps } from '../../data/portfolioData';
import coinPrices, { CoinProps } from '../../data/coinPrices';
import { PFTotalBg, PFTotalItem } from '../../components/Portfolio/PortfolioBoxUI';

type Props = {
  balances: PFBalanceProps[];
};

const PFTotal: React.SFC<Props> = ({ balances }) => {
  const btcValue = 7052.45;
  const totalUSD = _(balances).reduce((agg: BigNumber, balance: PFBalanceProps) => {
    const coin: CoinProps = coinPrices[balance.coinId];
    const priceUSD = new BigNumber(balance.amount).times(coin.quotes.btc.price).times(btcValue);
    return agg.plus(priceUSD);
  }, new BigNumber(0));
  const totalBTC = _(balances).reduce((agg: BigNumber, balance: PFBalanceProps) => {
    const coin: CoinProps = coinPrices[balance.coinId];
    const priceUSD = new BigNumber(balance.amount).times(coin.quotes.btc.price);
    return agg.plus(priceUSD);
  }, new BigNumber(0));
  const totalUSDFmt = numeral(totalUSD).format('$0,0.00');
  const totalBTCFmt = numeral(totalBTC).format('0,0.00');
  return (
    <PFTotalBg>
      <PFTotalItem>Total: {totalUSDFmt}</PFTotalItem>
      <PFTotalItem>BTC: {totalBTCFmt}</PFTotalItem>
    </PFTotalBg>
  );
};

export default PFTotal;



// WEBPACK FOOTER //
// ./src/containers/Portfolio/PFTotal.tsx